import "./panel.css";
